import * as React from "react";

export default function PrivacyPolicy() {
  return (
    <main className="container mx-auto max-w-3xl px-4 py-10">
      <div 
        className="rounded-xl border bg-white p-6 shadow-sm" 
        style={{ marginTop: "120px" }}
      >
        <h1 className="heading-1 mb-2">Privacy Policy</h1>
        <p className="body-small text-gray-600">Last updated: [December, 2025]</p>

        <div className="mt-6 space-y-4 text-sm leading-6 text-gray-700">
          <p>
            At <strong>Magomeal</strong>, we respect your privacy and are committed 
            to protecting your personal data. This policy explains how we collect, use, 
            and store information when you visit our website or place an order.
          </p>
          <p>
            We only collect the data necessary to process your orders, communicate 
            with you, and improve our services. We never sell or share your data 
            with third parties except when required to deliver your order 
            (e.g., with shipping carriers).
          </p>
          <p>
            You have the right to request access, correction, or deletion of your 
            personal data at any time. Please contact us at 
            <a href="mailto:info@magomeal.nl" className="underline"> info@magomeal.nl</a>.
          </p>
        </div>
      </div>
    </main>
  );
}
